import type { Locale } from '../locales'
import { translatorFor, type TranslateWith } from '../translate'
import { ca } from './ca'
import { en } from './en'
import { es, type EditorCatalog, type EditorMessageKey } from './es'

/*
 * The course editor's catalog (ADR 0009 §1): the editor is one for HR's console and for the back
 * office, which import it besides their own catalog, never each other's (ADR 0008 §2).
 */

export * from '../locales'
export type { MessageValues } from '../translate'
export type { EditorCatalog, EditorMessageKey }

export const editorCatalogs: Record<Locale, EditorCatalog> = { es, ca, en }

export type EditorTranslate = TranslateWith<EditorMessageKey>

export function createEditorTranslator(locale: Locale): EditorTranslate {
  return translatorFor(editorCatalogs[locale], locale)
}
